import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class ItemGroupService extends GenericService {
    constructor() {
        super('/item_groups', axiosInstance);
    }
}

export default new ItemGroupService(); 